import { Routes, Route, Navigate } from 'react-router-dom'

import { AppProvider } from '@!/providers'
import PaymentNewCard from '../containers/PaymentNewCard'
import PaymentMain from '../containers/PaymentMain'
import PaymentConfirm from '../containers/PaymentConfirm'
import PaymentSelect from '../containers/PaymentSelect'
import MonthlyCoursePaymentSelect from '@!/User/Payment/containers/MonthlyCourse/PaymentSelect'
import MonthlyCoursePaymentNewCard from '@!/User/Payment/containers/MonthlyCourse/NewCard'
import MonthlyCoursePaymentConfirm from '@!/User/Payment/containers/MonthlyCourse/PaymentConfirm'
import PaymentRedirect from '../containers/PaymentRedirect'
import { usePaymentSettings } from '@!/Hooks'
import { MonthlyCourses, PaymentCoinList } from '@!/User/Payment/components'

const PaymentApp = (props) => {
  const jotaiStore = usePaymentSettings({
    isSaveLastUrl: false,
    paymentList: props.payment_list,
    monthlyCourses: props.monthly_courses,
    tokenApiUrl: props.token_api_url,
    shopId: props.shop_id,
  })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Routes>
        <Route path="/" element={<PaymentMain />}>
          <Route index element={<Navigate to="monthly_course" replace />} />
          <Route path="monthly_course" element={<MonthlyCourses />} />
          <Route path="coin" element={<PaymentCoinList />} />
        </Route>
        <Route path="/new_card" element={<PaymentNewCard />} />
        <Route path="/confirm" element={<PaymentConfirm />} />
        <Route path="/select" element={<PaymentSelect />} />
        <Route path="/redirect" element={<PaymentRedirect />} />

        {/* 月額コース登録 */}
        <Route path="/monthly_course/select" element={<MonthlyCoursePaymentSelect restore={false} />} />
        <Route path="/monthly_course/new_card" element={<MonthlyCoursePaymentNewCard />} />
        <Route path="/monthly_course/confirm" element={<MonthlyCoursePaymentConfirm restore={false} />} />
      </Routes>
    </AppProvider>
  )
}

export default PaymentApp
